module.exports = __webpack_public_path__ + "img/bc_aspirin_powder_stick_packs.ff691dc3.jpg";